const dispatch = require("~/store.js").dispatch;

const events = require("./authenticationEvents.js");

const authenticationDispatchers = {
    Errored(error) {
        const errored = events.Errored.New(error);
        
        dispatch(errored);
    },
    ClearError() {
        const clear = events.ClearError.New();

        dispatch(clear);
    }
};

module.exports = authenticationDispatchers;


// WEBPACK FOOTER //
// ./src/events/authentication/authenticationDispatchers.js